import { ArrowLeft, Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 text-center">
      <div className="max-w-md space-y-6">
        <div className="mx-auto flex size-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Compass className="size-8" />
        </div>
        <div className="space-y-2">
          <p className="font-mono text-sm uppercase tracking-wider text-muted-foreground">
            Erro 404
          </p>
          <h1 className="text-3xl font-semibold tracking-tight">Rota fora do mapa</h1>
          <p className="text-sm text-muted-foreground">
            A página que você tentou acessar não existe ou foi movida de lugar.
          </p>
        </div>
        <Button asChild>
          <Link to="/app">
            <ArrowLeft className="size-4" />
            Voltar ao painel
          </Link>
        </Button>
      </div>
    </div>
  );
}
